
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1424 187"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 81.35c109.931-14.65 207.305 12.748 292.122 82.196C419.348 267.717 369.52-12.045 877.946 41.496 1386.37 95.037 1424 141.912 1424 52V0H0v81.35z","fill":"#90C3D6"}}),_c('path',{attrs:{"d":"M-.293 66.943c119.319-15.046 219.64 12.155 300.963 81.603 121.984 104.171 74.209-175.591 561.69-122.05 487.482 53.541 560.696-10.98 561.168-9.488.315.995.472-1.804.472-8.395L1423.528 0H0l-.293 20v46.943z","fill":"#9DCBDA"}})])])
          )
        }
      }
    